import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export type GrowthAudit = {
  id: string;
  created_at: string;
  audit_type: 'local_discovery' | 'visitor_readiness' | 'engagement_momentum';
  score: number;
  breakdown: Record<string, number>;
  findings: {
    severity: string;
    title: string;
    detail: string;
    evidence_urls?: string[];
  }[];
};

async function fetchLatestAudits(): Promise<GrowthAudit[]> {
  const { data, error } = await supabase
    .from('growth_audits')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(9);
  if (error) throw error;
  return (data ?? []) as GrowthAudit[];
}

export function useGrowthAudits() {
  return useQuery({
    queryKey: ['growth', 'audits'],
    queryFn: fetchLatestAudits,
  });
}
